import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Divider, Stack } from "@mui/material"

import type { EntryChange } from "types/changelog.types"

import { formatReleaseDate } from "helpers/utils/dateUtils"
import CardWithTitle from "widgets/common/CardWithTitle"
import Change from "./Change"

interface EntryProps {
  release: string
  changes: EntryChange[]
}

const Entry = ({ release, changes }: EntryProps) => {
  const { i18n } = useTranslation()
  const lang = useMemo(() => i18n.resolvedLanguage, [i18n])
  const formattedReleaseDate = useMemo(
    () => formatReleaseDate(release, lang || "en"),
    [release, lang],
  )

  return (
    <Stack mb={2}>
      <CardWithTitle titleKey={formattedReleaseDate}>
        <Stack divider={<Divider />} spacing={2}>
          {changes.map((change) => (
            <Change key={change.title} change={change} />
          ))}
        </Stack>
      </CardWithTitle>
    </Stack>
  )
}

export default Entry
